import { Routes } from '@angular/router';
import { WelcomeComponent } from '@tsin-pages/welcome/welcome.component';
import { AuthWrapperComponent } from './layout/auth-wrapper/auth-wrapper.component';
import { ManagementComponent } from '@tsin-pages/management/management.component';
import { adminGuard } from '@tsin-core/guards/admin.guard';
import { otpGuard } from '@tsin-core/guards/otp.guard';
import { preOtpGuard } from '@tsin-core/guards/pre-otp.guard';
import { setLanguageGuard } from '@tsin-core/guards/set-language.guard';

export const routes: Routes = [
    // Redirect the empty path to the welcome page
    { path: '', redirectTo: 'welcome', pathMatch: 'full' },
    // Welcome page route — always English
    { path: 'welcome', component: WelcomeComponent, canActivate: [setLanguageGuard('en')] },

    // --- French entry points ---
    // /fr  →  /fr/welcome  (language guard fires first)
    { path: 'fr', redirectTo: 'fr/welcome', pathMatch: 'full' },
    {
        path: 'fr/welcome',
        component: WelcomeComponent,
        canActivate: [setLanguageGuard('fr')],
    },
    {
        path: 'fr/login',
        component: AuthWrapperComponent,
        canActivate: [setLanguageGuard('fr')],
        loadChildren: () => import('./pages/auth/login.routes'),
    },
    {
        path: 'fr/create-account',
        canActivate: [setLanguageGuard('fr')],
        loadChildren: () => import('./pages/create-account/create-account.routes'),
    },
    {
        path: 'fr/auth',
        component: AuthWrapperComponent,
        canActivate: [setLanguageGuard('fr')],
        loadChildren: () => import('./pages/auth/auth.routes'),
    },
    // ----------------------------

    {
        path: 'login',
        component: AuthWrapperComponent,
        canActivate: [setLanguageGuard('en')],
        loadChildren: () => import('./pages/auth/login.routes'),
    },
    {
        path: 'auth',
        component: AuthWrapperComponent,
        canActivate: [setLanguageGuard('en')],
        loadChildren: () => import('./pages/auth/auth.routes'),
    },
    {
        path: 'verify-email',
        component: AuthWrapperComponent,
        loadChildren: () => import('./pages/auth/verify-email.routes'),
    },
    {
        path: 'create-account',
        canActivate: [setLanguageGuard('en')],
        loadChildren: () => import('./pages/create-account/create-account.routes'),
    },
    {
        path: 'otp',
        component: AuthWrapperComponent,
        canActivate: [preOtpGuard],
        loadChildren: () => import('./pages/otp/otp.routes'),
    },
    {
        path: 'user',
        canActivate: [otpGuard],
        loadChildren: () => import('./pages/user/user.routes'),
    },
    {
        path: 'management',
        component: ManagementComponent,
        canActivate: [adminGuard, otpGuard]
    },
    // Wildcard route for a 404 page or redirect to welcome
    { path: '**', redirectTo: 'welcome' }
];
